import theme from '@styles/theme';
export default {
  searchBoxContainer: {
    position: 'fixed',
    width: '100%',
    top: '0',
    left: '0',
    background: theme.rawColors.neutralWhite,
    zIndex: theme.zIndex.search
  },
  searchBoxWrapper: {
    height: ['72px', '72px', '72px', '72px', '100px'],
    width: '100%',
    maxWidth: '1920px',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 'auto',
    padding: ['16px', '16px', '16px 24px', '16px 24px', '30px 40px', '30px 60px', '30px 80px']
  },
  fromContainer: {
    width: '100%'
  },
  searchBox: {
    width: '100%',
    height: '20px',
    margin: ['0 16px', '0 16px', '0 24px'],
    fontSize: '18px',
    border: 'none',
    boxShadow: 'none',
    fontFamily: theme.fonts.uniform,
    '&:focus': {
      outline: 'none',
      boxShadow: 'none'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.blue500}`,
      outlineOffset: '2px'
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    },
    '&::placeholder': {
      color: theme.rawColors.darkGrey700,
      letterSpacing: theme.letterSpacings.caps
    }
  }
};